/**
 * FX Hero Effects
 *
 * @file   fx.js
 * @author Dan Griffin
 */
jQuery(document).ready(function($) {
	
	var debug = window.tg_debug ? true : false;
	var animationTime = 13000;
	
	if($(".page-template-page-hero").length <= 0) {
		if(debug) {  
			console.log("No Hero here - skip timer.");
		}
		return;
	}
	
	var interval
	
	var rerunAnimation = function() { 
		if(debug) {  
			console.log("Restarting animation...");
		}
		
	    clearInterval(interval);
		$('.rw-words').addClass("running");
		interval = setInterval(resetHomeAnimation, animationTime);
	}

	var resetHomeAnimation = function() { 
		if(debug) {  
			console.log("Resetting animation...");
		}
		
	    clearInterval(interval);
		$('.rw-words').removeClass("running")
		interval = setInterval(rerunAnimation, 100);
	};

	$('.page-template-page-hero').ready(function() {
	    clearInterval(interval);
	    interval = setInterval(resetHomeAnimation, animationTime); // create new interval   
	});
});